import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { SoldToAddress } from "@dana/Types/ApiModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsShippingAddressStyles {
    titleText?: TypographyProps;
    addressDisplay?: AddressInfoDisplayStyles;
    wrapper?: InjectableCss;
}

export const shippingAddressStyles: OrderDetailsShippingAddressStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
            padding-top: 10px;
        `,
    },
};

const styles = shippingAddressStyles;

const OrderDetailsSoldToAddress: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    const soldToObj: SoldToAddress | undefined = order?.properties?.soldToAddress
        ? JSON.parse(order.properties.soldToAddress)
        : undefined;    

    return (
        <>       
          <StyledWrapper {...styles.wrapper} data-test-selector="orderDetailShippingInformation">
          <Typography {...styles.titleText} className="text-body-md">
              {`${translate("Sold To")}: ${soldToObj?.CustomerSequence}`}
          </Typography>
          <AddressInfoDisplay
              companyName={soldToObj?.CompanyName || ""}
              address1={soldToObj?.Address1 || ""}
              address2={soldToObj?.Address2 || ""}            
              city={soldToObj?.City || ""}
              state={soldToObj?.State|| ""}
              postalCode={soldToObj?.PostalCode || ""}
              country={soldToObj?.Country ||""}
              extendedStyles={styles.addressDisplay}
          />
      </StyledWrapper>      
      </>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsSoldToAddress,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
